import React, { useCallback, useId } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, func, number, shape, string,
} from 'prop-types'

import { formatFileSize } from './formatFileSize'

function FileOption({ value, candidate, isSelected, onSelect }) {
  const { name, entryPath, format, fileSize } = candidate
  const inputId = useId()
  const handleChange = useCallback(() => onSelect(value), [onSelect, value])
  const details = [format?.toUpperCase(), formatFileSize(fileSize)].filter(Boolean).join(' - ')

  return (
    <label
      htmlFor={inputId}
      className={classnames('archive-file-option', isSelected && 'archive-file-option--selected')}
    >
      <input
        id={inputId}
        type="radio"
        name="archive-file"
        className="archive-file-option__input"
        value={value}
        checked={isSelected}
        onChange={handleChange}
      />
      <span className="archive-file-option__text">
        <span className="archive-file-option__name cgt-body-base-semibold">{name}</span>
        {entryPath !== name && (
          <span className="archive-file-option__path cgt-caption">{entryPath}</span>
        )}
      </span>
      {details && <span className="archive-file-option__details cgt-caption">{details}</span>}
    </label>
  )
}

FileOption.propTypes = {
  value: string.isRequired,
  candidate: shape({
    name: string.isRequired,
    entryPath: string.isRequired,
    format: string,
    fileSize: number,
  }).isRequired,
  isSelected: bool.isRequired,
  onSelect: func.isRequired,
}

export default FileOption
